<template>
  <div class="detailBox-box">
    <el-dialog
      width="1500px"
      title="分红详情"
      :visible.sync="dialogVisible"
      @closed="closeDialog"
    >
      <div class="box">
        <el-popover placement="top" width="260" v-model="grantVisible">
          <p style="color:#409EFF"><strong>请先选择发放币种!</strong></p>
          <el-select v-model="grantCoin" placeholder="请选择发放币种">
            <el-option
              v-for="item in selectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div style="text-align: right; margin-top: 20px">
            <el-button size="mini" type="text" @click="grantVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="mini" @click="grant()"
              >确定</el-button
            >
          </div>
          <el-button type="success" slot="reference">发放</el-button>
        </el-popover>

        <div>
          <el-form>
            <el-form-item label="对公账信息：">{{publicUserInfo}}</el-form-item>
          </el-form>
        </div>

        <el-card shadow="never" class="page-content">
          <div class="page-actions">
            <el-input v-model="userId" placeholder="请输入用户ID"></el-input>
            <el-select v-model="coinType" placeholder="请选择币种">
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-date-picker
              v-model="startTime"
              type="datetime"
              :editable="false"
              value-format="timestamp"
              placeholder="分红开始时间"
            >
            </el-date-picker>
            <el-date-picker
              v-model="endTime"
              type="datetime"
              :editable="false"
              value-format="timestamp"
              placeholder="分红结束时间"
            >
            </el-date-picker>
            <el-button type="primary" class="btn" @click="refreshList()"
              >查询</el-button
            >
          </div>
          <el-table :data="pairBounsRecordDetailInfo.records">
            <el-table-column label="ID" prop="id"></el-table-column>
            <el-table-column
              label="分红记录ID"
              prop="pairBounsRecordId"
            ></el-table-column>
            <el-table-column label="分红币种" prop="coinType"></el-table-column>
            <el-table-column
              label="分红数量"
              prop="bounsAmount"
            ></el-table-column>
            <el-table-column label="用户ID" prop="userId"></el-table-column>
            <el-table-column
              label="用户持仓数量"
              prop="userPositionAmount"
            ></el-table-column>

            <el-table-column label="状态">
              <template slot-scope="scope">
                {{ scope.row.userType === 1 ? '项目方' : '持仓用户' }}
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 0">待发放</span>
                <span v-else-if="scope.row.status === 1">发放成功</span>
                <span v-else-if="scope.row.status === 2">发放失败</span>
                <span v-else>未记录状态</span>
              </template>
            </el-table-column>
            <el-table-column label="分红时间" prop="lastBounsTime">
              <template slot-scope="scope">{{
                scope.row.updateTime | moment
              }}</template>
            </el-table-column>
          </el-table>
          <div class="pagination-box">
            <el-pagination
              layout="prev, pager, next, total, jumper"
              @current-change="pageChange"
              @size-change="sizeChange"
              :current-page="pairBounsRecordDetailInfo.page"
              :page-size="pairBounsRecordDetailInfo.size"
              :total="pairBounsRecordDetailInfo.total"
              prev-text="上一页"
              next-text="下一页"
            >
            </el-pagination>
          </div>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import '../store';
import Pagination from 'components/pagination';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'DetailBox',
  components: {
    Pagination
  },
  data() {
    return {
      dialogVisible: false,
      page: 1,
      size: 5,
      row: {},
      startTime: '',
      endTime: '',
      coinType: '',
      userId: '',
      grantCoin: '',
      grantVisible: false,
      selectOptions: []
    };
  },
  computed: {
    ...mapState('burnCoinBonus', ['pairBounsRecordDetailInfo','publicUserInfo'])
  },
  methods: {
    ...mapActions('burnCoinBonus', [
      'getPairBounsRecordDetailList',
      'getPublicUserInfo',
      'pairBounsGrant'
    ]),
    setVisible(val) {
      this.dialogVisible = val;
    },
    setInfo(row) {
      let selectArr = [];
      selectArr.push({ value: '', label: '请选择币种' });
      selectArr.push({ value: row.tradeCoin, label: row.tradeCoin });
      selectArr.push({ value: row.targetCoin, label: row.targetCoin });
      this.selectOptions = selectArr;
      this.row = row;
    },
    closeDialog() {
      this.userId = '';
      this.coinType = '';
      this.startTime = '';
      this.startTime = '';
      this.row = {};
      this.page = 1;
      this.dialogVisible = false;
    },

    refreshList() {
      this.getPairBounsRecordDetailList({
        pairBounsRecordId: this.row.id,
        coinType: this.coinType,
        endTime: this.endTime,
        page: this.page,
        size: this.size,
        startTime: this.startTime,
        userId: this.userId
      });
    },
    pageChange(e) {
      this.page = e;
      this.refreshList();
    },
    sizeChange(e) {
      this.page = e;
      this.refreshList();
    },
    handleCurrentChange(val) {
      this.page = val.page;
      this.refreshList();
    },

    grant() {
      if (this.grantCoin) {
        this.pairBounsGrant({
          coinType: this.grantCoin,
          id: this.row.id
        }).then(res => {
          if (!res.code) {
            this.refreshList();
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success'
            });
            this.grantVisible = false;
          }
        });
      }
    }
  },
  mounted() {},
  watch: {
    dialogVisible(newValue, oldValue) {
      if (newValue === true) {
        this.refreshList();
        this.getPublicUserInfo({pair:this.row.pair});
      }
    }
  }
};
</script>
<style lang="less" scoped>
.detailBox-box {
  .pagination-box {
    padding-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
